export default "__VITE_ASSET__981cc82e__"